<template>
    <v-dialog 
        :value="show"        
        fullscreen 
        hide-overlay
        @keydown.esc="close"
        transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn 
                    icon 
                    dark 
                    :disabled="saving" 
                    @click="close">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    <span v-if="originalItem">Edit Season</span>
                    <span v-else>Add New Season</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-layout row align-center justify-center fill-height v-if="loading">
                <v-flex shrink>
                    <v-progress-circular indeterminate></v-progress-circular>
                </v-flex>
            </v-layout>
            <v-form v-else ref="editForm" v-model="editValid">
                <v-layout class="dialog-content">
                    <v-flex xs12 md6 offset-md3>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-autocomplete
                                    label="Product Category"
                                    :items="productCategories"
                                    item-value="ProductCategoryID"
                                    item-text="Name"
                                    v-model="editedItem.ProductCategoryID"                                                
                                    :rules="[rules.requiredObject]"
                                    >
                                </v-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-menu v-model="editStartDate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field :value="editedItem.SeasonStartDate | formatDate" label="Date" prepend-icon="event" readonly v-on="on" :rules="[rules.required]" @click="editStartDate = true"></v-text-field>
                                    </template>
                                    <v-date-picker :value="editedItem.SeasonStartDate" @input="updateSeasonStartDate(editedItem, $event)"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12>
                                <v-menu v-model="editEndDate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field :value="editedItem.SeasonEndDate | formatDate" label="Date" prepend-icon="event" readonly v-on="on" :rules="[rules.required]" @click="editEndDate = true"></v-text-field>
                                    </template>
                                    <v-date-picker :value="editedItem.SeasonEndDate" @input="updateSeasonEndDate(editedItem, $event)"></v-date-picker>
                                </v-menu>
                            </v-flex>                                   
                        </v-layout>
                        <v-layout wrap class="dialog-action-buttons">
                            <v-flex xs12 sm6>
                                <v-btn 
                                    block 
                                    color="success" 
                                    :disabled="!editValid" 
                                    :loading="saving" 
                                    @click="save">
                                    <span>Save</span>
                                </v-btn>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-btn 
                                    block 
                                    color="error" 
                                    :disabled="saving" 
                                    @click="close">
                                    <span>Cancel</span>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-alert 
                                    :value="error" 
                                    outline 
                                    type="error">
                                    <span>{{ error }}</span>
                                </v-alert>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import plantConfigurationApi from "@/api/plantConfigurationApi";
import validationRules from "@/helpers/validationrules";
import BaseAPI from "@/api/baseApi";

export default {
    props: {
        plantID: {
            required: true,
            type: Number,
            default: null
        },
        originalItem: {
            required: false,
            type: Object,
            default: null
        },
        show: {
            required: true,
            type: Boolean,
            default: false
        },
        productCategories: {
            required: true,
            type: Array,
            default: null
        }
    },
    data() {
        return {
            rules: validationRules.rules,
            loading: false,
            editedItem: {},            
            saving: false,
            error: null,
            editValid: false,
            editStartDate: false,
            editEndDate: false,
        }
    },
    computed: {
    },    
    methods: {
        updateSeasonStartDate(item, value) {
            this.$set(item, 'SeasonStartDate', value);
            this.editStartDate = false;
        },
        updateSeasonEndDate(item, value) {
            this.$set(item, 'SeasonEndDate', value);
            this.editEndDate = false;
        },
        close(saved) {
            this.$refs.editForm.reset();
            this.$emit("close", saved);
        },
        async save() {
            try {
                this.saving = true;
                this.error = null;

                var result = await plantConfigurationApi.savePlantSeason(this.plantID, this.editedItem);

                if (!result.Success) {
                    this.error = result.ErrorMessages.join(', ');
                    return;
                }

                this.close(true);
            }
            catch (err) {
                this.error = await BaseAPI.parseHttpRequestError(err);
                throw err;
            }
            finally {
                this.saving = false;
            }
        }
    },
    async mounted() {
        if (this.originalItem) {
            this.editedItem = JSON.parse(JSON.stringify(this.originalItem));
            this.editedItem.SeasonStartDate = this.editedItem.SeasonStartDate.substring(0,10);
            this.editedItem.SeasonEndDate = this.editedItem.SeasonEndDate.substring(0,10)
        }
    },
}
</script>
<style scoped>
</style>